<template>
  <div>
    <div style="padding:20px;">
      <h2>订单基本信息</h2>
      <el-divider></el-divider>
      <el-form
        :model="orderForm"
        :size="$store.state.formSize"
        :rules="orderFormRules"
        ref="refOrderForm"
        label-width="130px"
        :inline="true"
      >
        <el-form-item label="订单编号：" prop="orderCode">
          <el-input v-model="orderForm.orderCode" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="销售商：" prop="merchantId">
          <el-select
            v-model="orderForm.merchantId"
            :placeholder="orderForm.merchantName"
            style="width:100%;"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.label"
              :value="item.value"
              :label="item.label"
              placeholder="请选择销售商"
              >{{ item.label }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="发货时间：" prop="sendDate">
          <el-date-picker
            v-model="orderForm.sendDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            :placeholder="orderForm.sendDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="发货人：" prop="deliveryName">
          <el-input
            v-model="orderForm.deliveryName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="发货人电话：" prop="deliveryPhone">
          <el-input
            v-model="orderForm.deliveryPhone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="发货地址：" prop="deliveryAddressList">
          <el-cascader
            :props="props"
            :placeholder="orderForm.deliveryAddressStr"
            v-model="orderForm.deliveryAddressStr"
            @change="townSelectDelivery($event)"
            @expand-change="citySelectDelivery($event)"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="发货详细地址：" prop="deliveryAddress">
          <el-input
            v-model="orderForm.deliveryAddress"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人：" prop="receiverName">
          <el-input
            v-model="orderForm.receiverName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人电话：" prop="receiverPhone">
          <el-input
            v-model="orderForm.receiverPhone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货地址：" prop="receiverAddressList">
          <el-cascader
            :props="props"
            :placeholder="orderForm.receiverAddressStr"
            v-model="orderForm.receiverAddressStr"
            @change="townSelectReceiver($event)"
            @expand-change="citySelectReceiver($event)"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="收货详细地址：" prop="receiverAddress">
          <el-input
            v-model="orderForm.receiverAddress"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >{{ saveBtnText }}</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetForm">取 消</el-button>
      </div>
      <OrderInfo
        ref="OrderInfoList"
        :isDetailDisabled="isDetailDisabled"
        :orderId="orderId"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import { putOrderAdd, getOrderDetail, postOrderEdit } from '@/api/order'
import { getTrackMerchant } from '@/api/merchant'
import { getCity } from '@/api/city'
import OrderInfo from './OrderInfo'
const createForm = () => ({
  id: null,
  // 发货地址
  deliveryAddress: '',
  // 发货地址列表
  deliveryAddressList: null,
  deliveryAddressStr: '',
  // 发货人省
  deliveryProvince: '',
  deliveryProvinceName: '',
  // 发货人市
  deliveryCity: null,
  deliveryCityName: '',
  // 发货人县
  deliveryCounty: null,
  deliveryCountyName: '',
  // 发货人乡
  deliveryTown: null,
  deliveryTownName: '',
  // 发货人
  deliveryName: '',
  // 联系电话
  deliveryPhone: '',
  // 销售商
  merchantId: null,
  merchantName: '',
  // 订单编号
  orderCode: '',
  // 收货地址列表
  receiverAddressList: null,
  receiverAddressStr: '',
  // 收货地址
  receiverAddress: '',
  // 收货人省
  receiverProvince: null,
  receiverProvinceName: '',
  // 收货人市
  receiverCity: null,
  receiverCityName: '',
  // 收货人县
  receiverCounty: null,
  receiverCountyName: '',
  // 收货人乡
  receiverTown: null,
  receiverTownName: '',
  // 收货人
  receiverName: '',
  // 联系电话
  receiverPhone: '',
  // 发货时间
  sendDate: ''
})
export default {
  components: {
    OrderInfo
  },
  data() {
    return {
      isDisabled: false,
      isDetailDisabled: true,
      currentID: null,
      merchantList: [],
      saveBtnText: '保 存',
      orderForm: createForm(),
      orderFormRules: {
        deliveryAddress: [
          { required: true, message: '请输入发货地址', trigger: 'blur' }
        ],
        deliveryName: [
          { required: true, message: '请输入发货人', trigger: 'blur' }
        ],
        deliveryPhone: [
          { required: true, message: '请输入发货人联系电话', trigger: 'blur' }
        ],
        merchantId: [
          { required: true, message: '请选择销售商', trigger: 'blur' }
        ],
        orderCode: [
          { required: true, message: '请输入订单编号', trigger: 'blur' }
        ],
        receiverAddress: [
          { required: true, message: '请输入收货地址', trigger: 'blur' }
        ],
        receiverName: [
          { required: true, message: '请输入收货人', trigger: 'blur' }
        ],
        receiverPhone: [
          { required: true, message: '请输入收货人联系电话', trigger: 'blur' }
        ],
        sendDate: [
          { required: true, message: '请选择发货时间', trigger: 'blur' }
        ],
        deliveryAddressList: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        receiverAddressList: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ]
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data).map(item => ({
              label: item.name,
              value: item.code + ',' + item.id,
              code: item.code,
              // 判断最后一层
              leaf: item.type > 3
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      }
    }
  },
  props: {
    orderId: {
      type: Number,
      default: null
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.orderSubmit)
  },
  methods: {
    hanleResetForm() {
      this.$set(this, 'orderForm', createForm())
      this.$refs.refOrderForm.clearValidate()
      this.$emit('cancel')
    },
    citySelectReceiver(event) {
      if (event.length > 2) {
        this.orderForm.receiverProvince = parseInt(event[0].split(',')[1])
        this.orderForm.receiverCity = parseInt(event[1].split(',')[1])
        this.orderForm.receiverCounty = parseInt(event[2].split(',')[1])
      }
    },
    townSelectReceiver(event) {
      this.orderForm.receiverTown = parseInt(event.split(',')[1])
      this.orderForm.receiverAddressList = 'ok'
    },
    citySelectDelivery(event) {
      if (event.length > 2) {
        this.orderForm.deliveryProvince = parseInt(event[0].split(',')[1])
        this.orderForm.deliveryCity = parseInt(event[1].split(',')[1])
        this.orderForm.deliveryCounty = parseInt(event[2].split(',')[1])
      }
    },
    townSelectDelivery(event) {
      this.orderForm.deliveryTown = parseInt(event.split(',')[1])
      this.orderForm.deliveryAddressList = 'ok'
    },
    // 设置编辑表单默认值
    setForm() {
      this.$set(this, 'orderForm', createForm())
      this.$refs.refOrderForm.clearValidate()
      console.log(this.orderId)
      if (this.orderId === null) {
        // 新增订单
        this.orderForm.orderCode = moment(new Date().getTime()).format('YYYYMMDDHHmmss') + Math.ceil(Math.random() * 100)
      } else {
        this.isDisabled = true
        this.isDetailDisabled = false
        // 订单详情
        getOrderDetail(this.orderId).then(res => {
          if (res.status === 1) {
            this.currentID = res.data.id
            this.orderForm.deliveryAddress = res.data.deliveryAddress
            this.orderForm.deliveryCity = res.data.deliveryCity
            this.orderForm.deliveryCityName = res.data.deliveryCityName
            this.orderForm.deliveryCounty = res.data.deliveryCounty
            this.orderForm.deliveryCountyName = res.data.deliveryCountyName
            this.orderForm.deliveryName = res.data.deliveryName
            this.orderForm.deliveryPhone = res.data.deliveryPhone
            this.orderForm.deliveryProvince = res.data.deliveryProvince
            this.orderForm.deliveryProvinceName = res.data.deliveryProvinceName
            this.orderForm.deliveryTown = res.data.deliveryTown
            this.orderForm.deliveryTownName = res.data.deliveryTownName
            this.orderForm.id = res.data.id
            this.orderForm.merchantId = res.data.merchantId
            this.orderForm.merchantName = res.data.merchantName
            this.orderForm.orderCode = res.data.orderCode
            this.orderForm.receiverAddress = res.data.receiverAddress
            this.orderForm.receiverCity = res.data.receiverCity
            this.orderForm.receiverCityName = res.data.receiverCityName
            this.orderForm.receiverCounty = res.data.receiverCounty
            this.orderForm.receiverCountyName = res.data.receiverCountyName
            this.orderForm.receiverName = res.data.receiverName
            this.orderForm.receiverPhone = res.data.receiverPhone
            this.orderForm.receiverProvince = res.data.receiverProvince
            this.orderForm.receiverProvinceName = res.data.receiverProvinceName
            this.orderForm.receiverTown = res.data.receiverTown
            this.orderForm.receiverTownName = res.data.receiverTownName
            this.orderForm.sendDate = moment(res.data.sendDate).format(
              'YYYY-MM-DD'
            )
            this.orderForm.deliveryAddressStr =
              res.data.deliveryProvinceName +
              '/' +
              res.data.deliveryCityName +
              '/' +
              res.data.deliveryCountyName +
              res.data.deliveryTownName
            this.orderForm.receiverAddressStr =
              res.data.receiverProvinceName +
              '/' +
              res.data.receiverCityName +
              '/' +
              res.data.receiverCountyName +
              res.data.receiverTownName
            this.orderForm.deliveryAddressList = 'ok'
            this.orderForm.receiverAddressList = 'ok'
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 保存订单基本信息
    orderSubmit() {
      this.$refs.refOrderForm.validate(valid => {
        if (!valid) return false
        console.log(this.currentID)
        const changeOrder = this.currentID ? postOrderEdit : putOrderAdd
        this.orderForm.id = this.currentID || undefined
        changeOrder(this.orderForm).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('编辑订单成功')
              : this.$message.success('新增订单成功')
            this.orderFormVisible = false
            this.isDetailDisabled = false
            this.saveBtnText = '保存修改'
            if (res.data) {
              this.currentID = res.data
              this.orderId = res.data
            }
            this.$emit('afterRefresh')
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 获取销售商列表
    getSupplierListData() {
      getTrackMerchant({
        type: 2,
        page: 1,
        size: 1000
      }).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({
              label: res.data.rows[i].merchantName,
              value: res.data.rows[i].id
            })
          }
          this.merchantList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getSupplierListData()
  }
}
</script>
<style lang="scss" scoped>
.el-select,
.el-cascader,
.el-date-editor,
.el-input {
  width: 215px !important;
}
</style>
